import { Link } from "react-router-dom";
import { formatEventWhen, formatINR } from "@/lib/sections";
import { ArrowUpRight } from "lucide-react";

export default function EventCard({ event, testIdPrefix = "event-card" }) {
  return (
    <Link
      to={`/events/${event.slug}`}
      data-testid={`${testIdPrefix}-${event.slug}`}
      className="group block"
    >
      <div className="aspect-[4/5] overflow-hidden bg-cream-2 border border-soft">
        <img
          src={event.image_url?.startsWith("/") ? process.env.REACT_APP_BACKEND_URL + event.image_url : event.image_url}
          alt={event.title}
          loading="lazy"
          className="reveal-img w-full h-full object-contain"
        />
      </div>
      <div className="pt-5 flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="overline">{event.section?.replace('-', ' ')} · {event.category}</div>
          <h3 className="font-serif text-2xl mt-2 tracking-tight">{event.title}</h3>
          <p className="text-sm text-muted2 mt-2 line-clamp-2">{event.short_description}</p>
          <div className="mt-3 text-xs text-muted2">
            {formatEventWhen(event)}
          </div>
        </div>
        <div className="text-right shrink-0">
          <div className="font-serif text-xl">{event.price_inr > 0 ? formatINR(event.price_inr) : "Free"}</div>
          <ArrowUpRight size={18} className="ml-auto mt-2 text-charcoal opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
        </div>
      </div>
    </Link>
  );
}
